export const PageSizeSettingsOptions = [
  {value: 15, label: '15'},
  {value: 25, label: '25'},
  {value: 50, label: '50'},
  {value: 75, label: '75'},
];
